export const isProbablyMobile = navigator.userAgent
  .toLowerCase()
  .includes('mobi');
